import { useMutation } from '@/react-query/hooks/useMutation/useMutation';
import { hoslogPostQueries } from '@/services/hoslog-plans/hoslog-plans.queries';
import { revalidate } from '@/services/revalidate/revalidate';
import { useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';

const useHoslogPlansMutation = () => {
  const queryClient = useQueryClient();
  const { mutateAsync, isPending } = useMutation('createPlan', {
    onSuccess: async (res) => {
      await queryClient.invalidateQueries({ queryKey: [...hoslogPostQueries.all(), 'list'] });
      await revalidate(['adminPlans']);
      toast.success(res.message);
    },
    onError: (error) => {
      toast.error(error.message);
    },
  });

  return { mutateAsync, isPending };
};

export default useHoslogPlansMutation;
